"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TBYoutubeEmbed = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@storyblok/react");
var helpers_1 = require("../../helpers");
var TBYoutubeEmbed = function (_a) {
    var blok = _a.blok;
    var dimensions = (0, helpers_1.useWindowDimensions)();
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "".concat((0, helpers_1.topiaBlockClassnames)(blok), " cursor-pointer") }, (0, react_1.storyblokEditable)(blok), { children: (0, jsx_runtime_1.jsx)("iframe", { style: dimensions.width > 600
                ? { height: "335px", width: "552px" }
                : { width: "300px", height: "182px" }, className: "relative z-10 mx-auto my-8 rounded-lg lg:my-0", 
            // src={`https://www.youtube.com/embed/VACCpfTHIcA`}
            src: "https://www.youtube.com/embed/".concat(blok.youtube_id), title: blok.name, allowFullScreen: true }) })));
};
exports.TBYoutubeEmbed = TBYoutubeEmbed;
